import { useContext } from 'react';
import { SignalRContext, type SignalRContextType } from './context';

export const useSignalR = (): SignalRContextType => {
  const context = useContext(SignalRContext);
  if (!context) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }
  return context;
};
